import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
export function expiresAt(expiresIn) {
  var timeNow = Math.round(Date.now() / 1000);
  return timeNow + expiresIn;
}
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
export var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};
export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage(localStorage) {
    _classCallCheck(this, LocalStorage);

    this.localStorage = localStorage || globalThis.localStorage;
  }

  _createClass(LocalStorage, [{
    key: "clear",
    value: function clear() {
      return this.localStorage.clear();
    }
  }, {
    key: "key",
    value: function key(index) {
      return this.localStorage.key(index);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return this.localStorage.setItem(key, value);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.localStorage.getItem(key);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return this.localStorage.removeItem(key);
    }
  }]);

  return LocalStorage;
}();